import { Trans } from "react-i18next";
import { Terms } from "~/constants/terms";
import * as S from "./termsAndConditions.style";

export const TermsAndConditions = ({
  color,
  textDecoration,
}: S.IAnchorText) => {
  return (
    <Trans
      i18nKey="checkout.terms"
      components={{
        1: (
          <S.AnchorText
            color={color}
            textDecoration={textDecoration}
            href={Terms.privacy}
            target="_blank"
          />
        ),
        2: (
          <S.AnchorText
            color={color}
            textDecoration={textDecoration}
            href={Terms.terms}
            target="_blank"
          />
        ),
        3: (
          <S.AnchorText
            color={color}
            textDecoration={textDecoration}
            href={Terms.refund}
            target="_blank"
          />
        ),
      }}
    />
  );
};
